<template>

    <FloatingPanel>

        <div class="canvas-blocks-sky-price-BlockPanel">

            <SwitchInput
                label="Toon disclaimer?"
                :options="options"
                options-property="show_disclaimer"
                :items="[
                    { value: '1', label: 'Ja'},
                    { value: '0', label: 'Nee'},
                ]"
                defaultValue="1"
                :open="true"
            />

            <CommonInputs
                :options="options"    
            />

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        SwitchInput,
    },

}

</script>